module.exports = __webpack_public_path__ + "assets/character-spacing.01e779c0.svg";